// Module
var code = `<div class="editor-modal modal fade" role="dialog">
	<div class="modal-dialog">

		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"></h4>
				<button type="button" class="close" data-dismiss="modal">&times;</button>
			</div>
			<div class="modal-error alert alert-danger">

			</div>
			<div class="modal-body">

			</div>
			<div class="modal-footer">
				<i class="spinner fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
				<button class="modal-submit" type="button" class="btn btn-default">Insert</button>
			</div>
		</div>

	</div>
</div>
`;
// Exports
export default code;